// FORCE_CHANGE_PASSWORD is Cognito's pending-invite state. SSO users are CONFIRMED in Cognito as soon as they're
// created, so the backend reports SSO_PASSWORD_NOT_SET until they've set their Access Identity password.
const RESENDABLE_INVITE_STATUSES = new Set(["FORCE_CHANGE_PASSWORD", "SSO_PASSWORD_NOT_SET"])

export function canResendInvite(inviteStatus: string | null): boolean {
	return inviteStatus !== null && RESENDABLE_INVITE_STATUSES.has(inviteStatus)
}
